import styled from "styled-components";
import { Button } from "react-bootstrap";
import { SafeStaffMember } from "../../library/model/SafeStaffMember";
import { RouteComponentProps, withRouter } from "react-router";

const StaffCard = styled.div`
  background: white;
  border-radius: 15px;
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const StaffPhoto = styled.div`
  height: 200px;
  background: #e9ecef;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
`;

const StaffCardBody = styled.div`
  padding: 1.5rem;
  flex-grow: 1;
`;

const StaffName = styled.h4`
  font-weight: bold;
  margin-bottom: 0.5rem;
`;

const StaffDescription = styled.p`
  color: #6c757d;
`;

const StaffCardFooter = styled.div`
  padding: 1.5rem;
  border-top: 1px solid #e9ecef;
`;

interface Props extends RouteComponentProps<any> {
    book: boolean;
    staffMember: SafeStaffMember;
}

function AboutStaffMember(props: Props) {
    const {staffMember} = props;
    return (
        <StaffCard>
            <StaffPhoto />
            <StaffCardBody>
                <StaffName>{staffMember.name}</StaffName>
                <StaffDescription>{staffMember.description}</StaffDescription>
            </StaffCardBody>
            <StaffCardFooter>
                {props.book && (
                    <Button variant="primary" onClick={() => props.history.replace("/wizyta")}>
                        Umów wizytę
                    </Button>
                )}
            </StaffCardFooter>
        </StaffCard>
    );
}

export default withRouter(AboutStaffMember);
